import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, ChevronRight } from 'lucide-react';
export function Faq() {
  const faqs = [{
    question: '"¿Pero yo puedo pagarlo?"',
    answer: 'La respuesta casi siempre es SÍ. Existen programas y subsidios del gobierno que pueden reducir dramáticamente el costo de tu seguro de salud. Muchas familias califican para planes con costos muy bajos o incluso $0 al mes dependiendo de sus ingresos.'
  }, {
    question: '"¿Es complicado aplicar?"',
    answer: 'Para nada. Yo me encargo de TODO el proceso por ti. Tú solo me dices lo que necesitas y yo encuentro el plan perfecto para tu familia.'
  }, {
    question: '"¿Y si ya tengo un seguro?"',
    answer: 'Permíteme revisarlo sin costo ni compromiso. Es posible que estés pagando de más o que tu plan actual no te cubra lo que realmente necesitas.'
  }, {
    question: '"¿Puedo confiar en ti?"',
    answer: 'Soy una agente licenciada, con años de experiencia, y mi reputación está construida sobre la confianza de cientos de familias latinas como la tuya. Mi éxito depende de que tú estés satisfecho.'
  }, {
    question: '"Soy saludable, no necesito seguro"',
    answer: 'Los accidentes no avisan. La protección es para cuando menos lo esperas. Una sola visita a emergencias puede costar decenas de miles de dólares.'
  }, {
    question: '"¿Solo puedo inscribirme en noviembre?"',
    answer: '¡No! Existen Períodos Especiales de Inscripción disponibles todo el año. Llámame y verificamos tu caso hoy mismo.'
  }];
  return <section className="py-10 md:py-24 bg-white" data-id="element-53">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-55">
          <div className="flex justify-center mb-4" data-id="element-56">
            <HelpCircle className="w-12 h-12 text-navy" data-id="element-57" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-58">
            SÉ LO QUE ESTÁS PENSANDO...
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-59" />
        </motion.div>

        <div className="space-y-4" data-id="element-60">
          {faqs.map((faq, index) => <FaqItem key={index} question={faq.question} answer={faq.answer} index={index} data-id="element-61" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-62">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 bg-cream hover:bg-cream-dark transition-colors text-left" data-id="element-63">
        <span className="font-serif font-bold text-navy text-lg" data-id="element-64">
          {question}
        </span>
        <ChevronRight className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`} data-id="element-65" />
      </button>
      <AnimatePresence data-id="element-66">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-67">
            <div className="p-6 bg-white text-gray-700 border-t border-gray-100 leading-relaxed" data-id="element-68">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}